import { Component, OnInit, ViewChild } from '@angular/core';
import { Message } from 'primeng/api';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { AlertService } from '../../services/AlertService';
import { DealService } from '../../services/DealService';
import { AccountService } from '../../services/AccountService';
import { UserService } from '../../services/UserService';
import { LookupValuesService } from '../../common/lookup-values.service';
import { DealActionEnum } from '../../common/constants';
import { MemberService } from 'src/app/services/MemberService';

enum SearchBrokerTypeEnum {
    Sending = 1,
    Receiving = 2,
}

@Component({
  selector: 'app-deal-add',
  templateUrl: './deal-add.component.html',
  styleUrls: ['./deal-add.component.scss']
})

export class DealAddComponent implements OnInit {
    @ViewChild('f', { static: true }) dealAddForm: NgForm;
    @ViewChild(ValidateformComponent, { static: true }) private formValidator: ValidateformComponent;

    deal: any = {};
    options: any;
    msgs: Message[];
    dealTypeOptions: any[] = [];
    propertyTypeOptions: any[] = [];
    unitOfMeasurementTypeOptions: any[] = [];
    countryOptions: any[] = [];
    stateOptions: any[] = [];
    sendingBroker: any = {};
    receivingBroker: any = {};

    searchBrokerDialogVisible: boolean = false;
    searchBrokerText: string = '';
    searchBrokerResultList: any[] = [];
    searchBrokerDialogMessage: string = '';
    searchBrokerType: SearchBrokerTypeEnum = 1;
    isAdmin: boolean = false;
    searchByLocationVisible: boolean = false; 
    address: string = '';
    canUpdateSendingBroker:boolean = false; 

    constructor(private breadcrumbService: AppBreadcrumbService,
        private activatedRoute: ActivatedRoute,
        private alertService: AlertService,
        private dealService: DealService,
        private accountService: AccountService,
        private userService: UserService,
        private lookupvaluesservice: LookupValuesService,
        private router: Router,
        private memberservice: MemberService
    ) { }

    ngOnInit(): void {
        this.breadcrumbService.setItems([
            this.breadcrumbService.deal,
            this.breadcrumbService.dealAdd,
        ]);
        this.options = this.activatedRoute.snapshot.data['options'];
        this.parseOptions();
        this.initializeVariables();
        this.canUpdateSendingBroker = this.accountService.CanUpdateSendingBroker();
        this.isAdmin = this.accountService.IsAdmin;
    }

    initializeVariables() {
        this.searchBrokerType = 1;
        this.selectBroker(this.accountService.userValue.broker);
        this.deal.PropertyCountryID = 221;
        this.deal.PropertyState = '';
        this.setCountry(this.deal.PropertyCountryID);
        this.deal.CommissionNAI = 10;
    }

    parseOptions() {
        this.dealTypeOptions = new Array();
        for (let o of this.options[0]) {
            let l = o.Name;
            this.dealTypeOptions.push({ label: l, value: o.Id });
        }

        this.propertyTypeOptions = new Array();
        for (let o of this.options[1]) {
            let l = o.Name;
            this.propertyTypeOptions.push({ label: l, value: o.Id });
        }

        this.unitOfMeasurementTypeOptions = new Array();
        for (let o of this.options[2]) {
            let l = o.Name;
            this.unitOfMeasurementTypeOptions.push({ label: l, value: o.Id });
        }

        this.countryOptions = new Array();
        for (let o of this.options[3]) {
            let l = o.Name;
            this.countryOptions.push({ label: l, value: o.Id });
        }        
    }

    cancelAdd() {
        window.history.back();
    }

    saveAsDraft() {
        if (this.deal.Title == undefined || this.deal.Title.trim() == '') {
            this.alertService.SetMessage('warn', 'Title is required');
        }
        else {
            this.setBrokers();
            this.deal.NewActionID = DealActionEnum.SaveNew;
            this.dealService.PostDealData(this.deal).subscribe(
                result => {
                    if (result.Id != null) {
                        this.router.navigate(['/deal/' + result.Id]);
                        this.alertService.SetMessage('success', 'Deal is saved as draft');
                    }
                    else {
                        this.alertService.SetMessage('error', 'There is an error while saving deal as draft');
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while saving deal as draft');
                }
            );
        }      
    }

    saveAndPropose() {
        // if (this.deal.PropertyCountryID == 221 && this.deal.PropertyStateID == undefined) {
        //     this.dealAddForm.form.controls['PropertyStateID'].setErrors({ 'required': true });
        // }

        // if (this.deal.PropertyCountryID != 221 && this.deal.PropertyState == '') {
        //     this.dealAddForm.form.controls['PropertyState'].setErrors({ 'required': true });
        // }

        if (this.formValidator.validateForm()) {
            if(this.deal.PropertyStateID == undefined && this.deal.PropertyState == '' )
                {
    
                    this.alertService.SetMessage('warn', 'Property State is required. If the address does not have a State, please enter "N/A" in the State textbox.' );
                    return; 
     
                }
            if (this.receivingBroker.Id == undefined) {
                this.alertService.SetMessage('warn', 'Receiving broker is required');
            }
            else {
                this.setBrokers();
                this.deal.NewActionID = DealActionEnum.Propose;
                this.dealService.PostDealData(this.deal).subscribe(
                    result => {
                        if (result.Id != null) {
                            this.router.navigate(['/deal/' + result.Id]);
                            this.alertService.SetMessage('success', 'Deal is saved and proposed');
                        }
                        else {
                            this.alertService.SetMessage('error', 'There is an error while saving deal and proposing');
                        }
                    },
                    error => {
                        this.alertService.SetMessage('error', 'There is an error while saving deal and proposing');
                    }
                );
            }          
        }
    }

    setBrokers() {
        this.deal.ProposingUserID = this.sendingBroker.Id;
        this.deal.ProposingAcceptDeal = false;
        this.deal.ProposingBrokerName = this.sendingBroker.FName + ' ' + this.sendingBroker.LName;
        if (this.sendingBroker.Manager != null) {
            this.deal.ProposingManagerID = this.sendingBroker.Manager.Id;
            this.deal.ProposingManagerName = this.sendingBroker.Manager.Name;
            this.deal.ProposingMemberID = this.sendingBroker.Manager.MemberId;
        }
      
        if (this.receivingBroker.Id != null) {
            this.deal.ReceivingUserID = this.receivingBroker.Id;
            this.deal.ReceivingAcceptDeal = false;
            this.deal.ReceivingBrokerName = this.receivingBroker.FName + ' ' + this.receivingBroker.LName;
            if (this.receivingBroker.Manager != null) {
                this.deal.ReceivingManagerID = this.receivingBroker.Manager.Id;
                this.deal.ReceivingManagerName = this.receivingBroker.Manager.Name;
                this.deal.ReceivingMemberID = this.receivingBroker.Manager.MemberId;
            }
        }
    }

    getBrokerName(broker) {
        let result = "Select a professional";
        if (broker.FName != undefined || broker.LName != undefined) {
            result = broker.FName + ' ' + broker.LName;
        }
        return result;
    }

    getMemberName(broker) {
        var result = '';
        result = broker.DefaultMemberName;       
        return result;
    }

    getbrokerListByDealAddress()
    {    
         this.searchBrokerResultList = [];
         this.searchBrokerDialogMessage = ''; 
         this.searchBrokerText = '';
         if (this.deal.PropertyCity != '' || this.deal.PropertyCountry != '' || this.deal.PropertyState != '') {
 
             this.address = [this.deal.PropertyCity, this.deal.PropertyState, this.deal.PropertyCountry].filter(Boolean).join(", ");
             this.memberservice.GetMemberByTerritoryAddress(this.address).subscribe(
                 res => {   
                     if (res.length == 0) {
                         this.searchBrokerDialogMessage = 'There are no suggested brokers for this deal address. Please email help@naiglobal.com';
                         this.searchBrokerDialogVisible = true;   
                     } 
                     else {                       
                         for (let i = 0; i < res.length; i++) {
                             if (res[i].AgentsAndStaff != null)
                                 this.searchBrokerResultList = [...this.searchBrokerResultList, ...res[i].AgentsAndStaff];
                          }                            
                             this.searchBrokerDialogMessage = '';
                             this.searchBrokerDialogVisible = true;                                       
                         }  
                     }                   
                 );                    
             }
         else
         {
             this.openEmptySearchDialog();            
         }     
         
     }
     getbrokerListBySendingMemberId()
     {    
          this.searchBrokerResultList = [];
          this.searchBrokerDialogMessage = ''; 
          this.searchBrokerText = '';
                 

          if (this.sendingBroker != null && this.sendingBroker.Members != null) {
              let member =  this.sendingBroker.Members.find(e => e.IsDefaultMember === true);            
              if(member != null)
              {
                this.memberservice.GetMemberById(member.MemberID).subscribe(
                    res => {   
                        if (res == null || res.AgentsAndStaff == null) {                         
                            this.openEmptySearchDialog()   
                        } 
                        else {                       
                                
                                this.searchBrokerResultList = [...this.searchBrokerResultList, ...res.AgentsAndStaff];                                                            
                                this.searchBrokerDialogMessage = '';
                                this.searchBrokerDialogVisible = true;                                       
                            }  
                        },   
                        error=> {this.openEmptySearchDialog();}                
                    );                    
                }
                else
                {
                    this.openEmptySearchDialog();
                }
            }
          else
          {
              this.openEmptySearchDialog();            
          }     
          
      }
 
     showSearchBrokerDialog(type) {        
 
         this.searchBrokerType = type;       
         this.searchByLocationVisible = false;
         if(type == 1)
         {               
            this.getbrokerListBySendingMemberId();
            
         }      
         if (type == 2) {        
             this.getbrokerListByDealAddress();   
             this.searchByLocationVisible = true;                                 
         }       
       
     }
     openEmptySearchDialog()
     {           
         this.searchBrokerResultList = [];             
         this.searchBrokerText = '';
         this.searchBrokerDialogMessage = '';
         this.searchBrokerDialogVisible = true;     
     }

    hideSearchBrokerDialog() {
        this.searchBrokerDialogVisible = false;
    }

    searchBroker() {
        this.searchBrokerResultList = [];
        this.searchBrokerDialogMessage = '';
        if (this.searchBrokerText != '') {
            this.userService.SearchUsers(this.searchBrokerText).subscribe(res => {
                if (res.length == 0) {
                    this.searchBrokerDialogMessage = 'There is no result.';
                } else {
                    this.searchBrokerResultList = res;
                }                
            });
        } else {
            this.searchBrokerDialogMessage = 'Search keywords is required';
        }
    }
    
    selectBroker(broker) {
       
        if(broker.Manager == null)
        {
             this.userService.GetManagerByUserID(broker.Id).subscribe(res => {
                broker.Manager = res;                             
            });
        }
        if (this.searchBrokerType == 1)
            this.sendingBroker = broker;
        else
            this.receivingBroker = broker;            
       
        this.hideSearchBrokerDialog();   
    }

    onChangeCountry() {
        this.setCountry(this.deal.PropertyCountryID);
    }

    setCountry(countryId) {
        this.deal.PropertyStateId = null;
        this.lookupvaluesservice.GetStateOptions(countryId).subscribe(res => {
            this.stateOptions = new Array();
            for (let o of res) {
                let l = o.Name;
                this.stateOptions.push({ label: l, value: o.Id });
            }
        });
    }

    CommissionKeyup(type) {
        switch (type) {
            case 1:
                if (this.deal.CommissionProposer <= (100 - this.deal.CommissionNAI)) {
                    this.deal.CommissionReceiver = (100 - this.deal.CommissionNAI) - this.deal.CommissionProposer;
                } else {
                    this.deal.CommissionReceiver = 0;
                }
                break;
            case 2:
                if (this.deal.CommissionReceiver <= (100 - this.deal.CommissionNAI)) {
                    this.deal.CommissionProposer = (100 - this.deal.CommissionNAI) - this.deal.CommissionReceiver;
                } else {
                    this.deal.CommissionProposer = 0;
                }
                break;           
        }
    }

    PaymentReceivedOnChange() {
        if (!this.deal.PaymentReceived) {
            this.deal.PaymentReceivedDate = null;
        }
    }

    DocumentReceivedOnChange() {
        if (!this.deal.DocumentReceived) {
            this.deal.DocumentReceivedDate = null;
        }
    }
    
}
